<ion-grid *ngIf="data" class=" ion-no-padding">
  <ion-row class="ion-align-items-stretch container">
    <ion-col class="banner-content" size-xs="12" size-sm="6" size-lg="7">
      <h3>{{ data.title }}</h3>
      <div class="desc" [innerHTML]="sanitizeService.sanitizeString(data.description)"></div>
      <ion-button *ngIf="fidelityCardUrl" [languageRouter]="[fidelityCardUrl]">
        {{ 'ACTIONS.SEE_MORE' | translate }}
      </ion-button>
    </ion-col>
    <ion-col class="banner-image" size-xs="12" size-sm="6" size-lg="5">
      <img loading="lazy" src="{{ data.imageUrl }}" />
    </ion-col>
  </ion-row>
</ion-grid>